// extracted by mini-css-extract-plugin
export default {"container":"DownloadHistory_container__IJU9b","title":"DownloadHistory_title__MhWu3"};